// values match person.title
// used by special filters
const creatorTitles = [
  { id: 'author', text: 'Author' },
  { id: 'illustrator', text: 'Illustrator' },
  { id: 'author-illustrator', text: 'Author/Illustrator' },
]

export default creatorTitles
